/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Prompt_EnableInputs */



/**
* | output |
* | --- |
* | "Enable notifications" |
*
* @param {Notifications_Prompt_EnableInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_prompt_enable = /** @type {((inputs?: Notifications_Prompt_EnableInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Prompt_EnableInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer les notifications")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar notificaciones")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ativar notificações")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva notifiche")
	return /** @type {LocalizedString} */ ("Enable notifications")
});